"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCollaboratorListPage = exports.joinViaSpace = exports.linkValid = exports.deleteLink = exports.getLinkList = exports.createLink = exports.getForbidStatus = exports.uploadMemberFile = exports.inviteEmailVerify = exports.reSendInvite = exports.sendInvite = exports.updateMemberTeam = exports.searchTeamAndMember = exports.addMemberSearchRes = exports.getTeamAndMemberWithoutSub = exports.addIsActivedMembersInSpace = exports.getSubTeams = exports.BatchDeleteMember = exports.singleDeleteMember = exports.updateMember = exports.deleteTeam = exports.readTeam = exports.createTeam = exports.updateTeamInfo = exports.getMemberListInSpace = exports.getNodeCollaboratorInfo = exports.getMemberInfo = exports.getMemberList = exports.getTeamListLayered = exports.getUnitsByMember = void 0;
const axios_1 = __importDefault(require("axios"));
const Url = __importStar(require("../../shared/api/url"));
const CancelToken = axios_1.default.CancelToken;
/**
 * Query the list of units(member/group) in the space's organization
 * @returns
 */
function getUnitsByMember() {
    return axios_1.default.get(Url.MEMBER_UNITS);
}
exports.getUnitsByMember = getUnitsByMember;
function getTeamListLayered() {
    return axios_1.default.get(Url.TEAM_LIST_LAYERED);
}
exports.getTeamListLayered = getTeamListLayered;
/**
 * Contact list, get members
 *
 * @param teamId team ID, if empty, return root team, default 0
 */
function getMemberList(teamId) {
    return axios_1.default.get(Url.MEMBER_LIST, {
        params: {
            teamId,
        },
    });
}
exports.getMemberList = getMemberList;
/**
 * Get member info
 *
 * @param memberId  Contact member id
 * @param userId   user id
 */
function getMemberInfo({ memberId, uuid }) {
    return axios_1.default.get(Url.MEMBER_INFO, {
        params: {
            memberId,
            uuid,
        },
    });
}
exports.getMemberInfo = getMemberInfo;
function getNodeCollaboratorInfo({ uuid, nodeId }) {
    return axios_1.default.get(Url.COLLABORATOR_INFO, {
        params: {
            uuid,
            nodeId
        },
    });
}
exports.getNodeCollaboratorInfo = getNodeCollaboratorInfo;
/**
 * Get member list by pagination
 *
 * @param pageObjectParams pagination params
 * @param teamId if empty return root team, default 0
 * @param isActive whether the member has joined space
 */
function getMemberListInSpace(pageObjectParams, teamId, isActive) {
    return axios_1.default.get(Url.MEMBER_LIST_IN_SPACE, {
        params: {
            pageObjectParams,
            teamId,
            isActive,
        },
    });
}
exports.getMemberListInSpace = getMemberListInSpace;
/**
 * Update Team Info
 * edit the team
 *
 * @param teamId
 * @param superId parent team ID,if empty return root team, default 0
 * @param teamName team name
 */
function updateTeamInfo(teamId, superId, teamName) {
    return axios_1.default.post(Url.UPDATE_TEAM, {
        teamId,
        teamName,
        superId,
    });
}
exports.updateTeamInfo = updateTeamInfo;
/**
 * Create Team
 *
 * @param name
 * @param superId parent team id, if empty return root team, default 0
 */
function createTeam(name, superId) {
    return axios_1.default.post(Url.CREATE_TEAM, {
        name,
        superId,
    });
}
exports.createTeam = createTeam;
/**
 * Get Team Info
 *
 * @param teamId
 */
function readTeam(teamId) {
    return axios_1.default.get(Url.READ_TEAM, {
        params: {
            teamId,
        },
    });
}
exports.readTeam = readTeam;
/**
 * Delete the team
 * @param teamId team ID
 */
function deleteTeam(teamId) {
    return axios_1.default.delete(`${Url.DELETE_TEAM}${teamId}`);
}
exports.deleteTeam = deleteTeam;
/**
 * Update Member Info
 *
 * @param data member info
 */
function updateMember(data) {
    return axios_1.default.post(Url.UPDATE_MEMBER, data);
}
exports.updateMember = updateMember;
/**
 * Delete single member
 *
 * @param teamId Team ID
 * @param memberId Member ID
 * @param action Delete Action(0:delete from inner team, 1:delete from organization)
 */
function singleDeleteMember(teamId, memberId, isDeepDel) {
    return axios_1.default.delete(Url.SINGLE_DELETE_MEMBER, {
        data: {
            memberId,
            teamId,
            action: isDeepDel ? 1 : 0,
        },
    });
}
exports.singleDeleteMember = singleDeleteMember;
/**
 * Batch Delete Members
 *
 * @param memberId Member ID
 * @param teamId Team ID
 * @param action Delete Action(0:delete from inner team, 1:delete from organization)
 */
function BatchDeleteMember(teamId, memberId, isDeepDel) {
    return axios_1.default.delete(Url.BATCH_DELETE_MEMBER, {
        data: {
            memberId,
            teamId,
            action: isDeepDel ? 1 : 0,
        },
    });
}
exports.BatchDeleteMember = BatchDeleteMember;
/**
 * Get Sub Teams
 *
 * @param teamId Team ID
 */
function getSubTeams(teamId) {
    return axios_1.default.get(Url.READ_SUB_TEAMS, {
        params: {
            teamId,
        },
    });
}
exports.getSubTeams = getSubTeams;
/**
 * Add active units(members,teams) to team
 *
 * @param unitList
 * @param teamId
 */
function addIsActivedMembersInSpace(unitList, teamId) {
    return axios_1.default.post(Url.TEAM_ADD_MEMBER, {
        unitList,
        teamId,
    });
}
exports.addIsActivedMembersInSpace = addIsActivedMembersInSpace;
/**
 * Get members by team(include members in the sub team)
 */
function getTeamAndMemberWithoutSub(teamId) {
    return axios_1.default.get(Url.TEAM_MEMBERS, {
        params: {
            teamId,
        },
    });
}
exports.getTeamAndMemberWithoutSub = getTeamAndMemberWithoutSub;
/**
 *
 * Search organization resources
 * search in the add department member UI modal
 *
 * @param keyword the keyword to search
 * @param className class style
 */
function addMemberSearchRes(keyword, className) {
    return axios_1.default.get(Url.GET_ADD_MEMBERS, {
        params: {
            keyword,
            className,
        },
    });
}
exports.addMemberSearchRes = addMemberSearchRes;
/**
 * Search Teams or Members
 *
 * @param keyword the keyword to search
 */
function searchTeamAndMember(keyword) {
    return axios_1.default.get(Url.SEARCH_TEAM_MEMBER, {
        params: {
            keyword,
            className: 'highLight',
        },
    });
}
exports.searchTeamAndMember = searchTeamAndMember;
/**
 * Update Member's Team
 * @param memberIds
 * @param preTeamId Original Team ID, required
 * @param newTeamIds New Team IDs list
 */
function updateMemberTeam(memberIds, newTeamIds, preTeamId) {
    return axios_1.default.post(Url.UPDATE_MEMBER_TEAM, {
        memberIds,
        newTeamIds,
        preTeamId,
    });
}
exports.updateMemberTeam = updateMemberTeam;
/**
 * Invite members(batch available)
 */
function sendInvite(invite, nodeId, nvcVal) {
    return axios_1.default.post(Url.SEND_INVITE, {
        invite,
        nodeId,
        data: nvcVal,
    });
}
exports.sendInvite = sendInvite;
/**
 * ReSend email to invite members
 *
 * @param email strict email format
 */
function reSendInvite(email) {
    return axios_1.default.post(Url.RESEND_INVITE, {
        email,
    });
}
exports.reSendInvite = reSendInvite;
/**
 * Invite Email Verify
 * @param token one-time invite token
 * @param from inviter
 */
function inviteEmailVerify(token) {
    return axios_1.default.post(Url.INVITE_EMAIL_VERIFY, {
        token,
    });
}
exports.inviteEmailVerify = inviteEmailVerify;
/**
 * Upload the contact file
 */
function uploadMemberFile(formData, onUploadProgress, ctx) {
    return axios_1.default.post(Url.UPLOAD_MEMBER_FILE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress,
        cancelToken: new CancelToken(ctx),
    });
}
exports.uploadMemberFile = uploadMemberFile;
/**
 * get the status of the forbidden on exporting the entire space to excel
 */
function getForbidStatus() {
    return axios_1.default.get(Url.FORBID_STATUS);
}
exports.getForbidStatus = getForbidStatus;
/**
 * generate/refresh the link
 * @param  teamId team ID
 */
function createLink(teamId, nodeId) {
    return axios_1.default.post(Url.CREATE_LINK, {
        teamId,
        nodeId,
    });
}
exports.createLink = createLink;
/**
 * Get links list
 * @returns
 */
function getLinkList() {
    return axios_1.default.get(Url.LINK_LIST);
}
exports.getLinkList = getLinkList;
/**
 * Delete team invite link
 *
 * @param teamId
 * @returns
 */
function deleteLink(teamId) {
    return axios_1.default.delete(Url.DELETE_LINK, { data: { teamId } });
}
exports.deleteLink = deleteLink;
/**
 * public link validation
 * @param token
 * @param nodeId
 * @returns
 */
function linkValid(token, nodeId) {
    return axios_1.default.post(Url.LINK_VALID, { token, nodeId });
}
exports.linkValid = linkValid;
/**
 * join space by public link
 *
 * @param token
 * @param nodeId
 * @returns
 */
function joinViaSpace(token, nodeId) {
    return axios_1.default.post(Url.JOIN_VIA_LINK, { token, nodeId });
}
exports.joinViaSpace = joinViaSpace;
function getCollaboratorListPage(pageObjectParams, nodeId) {
    return axios_1.default.get(Url.COLLABORATOR_LIST_PAGE, {
        params: {
            pageObjectParams,
            nodeId
        }
    });
}
exports.getCollaboratorListPage = getCollaboratorListPage;
//# sourceMappingURL=api.org.js.map